var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @class
 * @extends AstronomicalObject
 * @name Star
 * @desc 항성 클래스
 */
import { DEG_TO_RAD } from 'src/constants';
import { TextureLoader, Color, PointLight, Vector3 } from 'three';
import { Lensflare, LensflareElement } from 'three/examples/jsm/objects/Lensflare';
import { Planet } from 'src/lib/astronomical/Planet';
var Star = /** @class */ (function (_super) {
    __extends(Star, _super);
    function Star(data) {
        var _this = this;
        var astronomical = {
            id: data.id,
            name: data.name,
            mass: data.mass,
            radius: data.radius,
            material: data.material,
            sideralDay: data.sideralDay,
            orbit: data.orbit,
        };
        _this = _super.call(this, astronomical) || this;
        _this.flareSize = 100;
        _this.flareMapResource = 'static/images/effect/lensflare.png';
        _this.setStarBody();
        _this.setFlare();
        _this.setLight();
        return _this;
    }
    Star.prototype.setFlareSize = function (sizeRatio, screenHeight) {
        var delta = 30;
        this.flareSize = sizeRatio * screenHeight * delta;
    };
    Star.prototype.setFlarePosition = function (pos) {
        this.lensFlare.position.copy(pos);
    };
    Star.prototype.getScreenSizeRatio = function (camPos, fov) {
        var size = this.getObjectStageSize();
        var distance = new Vector3().sub(camPos).length();
        var height = 2 * Math.tan((fov * DEG_TO_RAD) / 2) * distance;
        return size / height;
    };
    Star.prototype.setStarBody = function () {
        this.root.add(this.body);
    };
    Star.prototype.setFlare = function () {
        var flareColor = new Color(0xffffff);
        flareColor.setHSL(0.57, 0.80, 0.97);
        var flareSize = this.flareSize;
        this.flareMap = new TextureLoader().load(this.flareMapResource);
        var newLensflare = new Lensflare();
        newLensflare.addElement(new LensflareElement(this.flareMap, flareSize, 0.0, flareColor));
        var light = new PointLight(0xffffff, 1.5, 100);
        light.add(newLensflare);
        this.lensFlare = light;
        this.root.add(light);
    };
    Star.prototype.setLight = function () {
        var color = 0xffffff;
        var light = new PointLight(color);
        this.root.add(light);
    };
    return Star;
}(Planet));
export { Star };
